import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { processWeeklySettlement } from "../utils/walletEngine";

function AdminSettlements() {
  const [wallets, setWallets] = useState([]);
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);

      const { data: walletData, error: walletError } = await supabase
        .from("wallets")
        .select("*")
        .order("updated_at", { ascending: false });

      if (walletError) throw walletError;

      const { data: batchData, error: batchError } = await supabase
        .from("settlement_batches")
        .select("*")
        .order("created_at", { ascending: false });

      if (batchError) throw batchError;

      setWallets(walletData || []);
      setBatches(batchData || []);
    } catch (error) {
      console.error("Admin settlements load error:", error);
      alert(error.message || "Failed to load settlements.");
    } finally {
      setLoading(false);
    }
  };

  const handleRunSettlement = async (role) => {
    try {
      await processWeeklySettlement(role);
      alert(`Weekly settlement processed for ${role}`);
      loadData();
    } catch (error) {
      console.error("Settlement run error:", error);
      alert(error.message || "Failed to process settlement.");
    }
  };

  const negativeWallets = wallets.filter(
    (item) => Number(item.available_balance || 0) < 0
  );

  const totalPending = wallets.reduce(
    (sum, item) => sum + Number(item.pending_balance || 0),
    0
  );

  const totalAvailable = wallets.reduce(
    (sum, item) => sum + Number(item.available_balance || 0),
    0
  );

  if (loading) {
    return <div style={page}><p>Loading settlement console...</p></div>;
  }

  return (
    <div style={page}>
      <h1>Admin Settlements</h1>
      <p style={sub}>Run weekly releases and monitor wallet health.</p>

      <div style={grid}>
        <div style={card}>
          <p style={label}>Total Available</p>
          <h2>₹{totalAvailable.toFixed(2)}</h2>
        </div>
        <div style={card}>
          <p style={label}>Total Pending</p>
          <h2>₹{totalPending.toFixed(2)}</h2>
        </div>
        <div style={card}>
          <p style={label}>Negative Wallets</p>
          <h2>{negativeWallets.length}</h2>
        </div>
      </div>

      <div style={actions}>
        <button style={btn} onClick={() => handleRunSettlement("worker")}>
          Run Worker Settlement
        </button>
        <button style={btn} onClick={() => handleRunSettlement("shop_owner")}>
          Run Shop Settlement
        </button>
      </div>

      <div style={sectionCard}>
        <h2>Wallets With Negative Balance</h2>
        {negativeWallets.length === 0 ? (
          <p style={sub}>No negative wallets right now.</p>
        ) : (
          <div style={{ display: "grid", gap: "12px" }}>
            {negativeWallets.map((item) => (
              <div key={item.id} style={listCard}>
                <div>
                  <strong>{item.owner_role}</strong>
                  <p style={small}>{item.owner_user_id}</p>
                </div>
                <div>
                  <strong>₹{Number(item.available_balance || 0).toFixed(2)}</strong>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={sectionCard}>
        <h2>Settlement Batches</h2>
        {batches.length === 0 ? (
          <p style={sub}>No batches yet.</p>
        ) : (
          <div style={{ display: "grid", gap: "12px" }}>
            {batches.map((batch) => (
              <div key={batch.id} style={listCard}>
                <div>
                  <strong>{batch.owner_role}</strong>
                  <p style={small}>
                    {new Date(batch.created_at).toLocaleString()}
                  </p>
                </div>
                <div style={{ textAlign: "right" }}>
                  <strong>{batch.status}</strong>
                  <p style={small}>
                    Released ₹{Number(batch.total_pending_released || 0).toFixed(2)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const page = {
  minHeight: "100vh",
  background: "#050505",
  color: "#fff",
  padding: "32px",
};

const sub = {
  color: "#b3b3b3",
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: "16px",
  marginTop: "24px",
};

const card = {
  background: "linear-gradient(180deg, #111, #0a0a0a)",
  border: "1px solid #222",
  borderRadius: "18px",
  padding: "20px",
};

const label = {
  color: "#999",
};

const actions = {
  display: "flex",
  gap: "12px",
  flexWrap: "wrap",
  marginTop: "20px",
};

const btn = {
  padding: "12px 18px",
  borderRadius: "10px",
  border: "none",
  background: "#fff",
  color: "#000",
  cursor: "pointer",
  fontWeight: "bold",
};

const sectionCard = {
  marginTop: "24px",
  background: "linear-gradient(180deg, #111, #0a0a0a)",
  border: "1px solid #222",
  borderRadius: "18px",
  padding: "22px",
};

const listCard = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "14px",
  background: "#0c0c0c",
  borderRadius: "12px",
  border: "1px solid #1f1f1f",
};

const small = {
  fontSize: "12px",
  color: "#999",
  marginTop: "4px",
  marginBottom: 0,
};

export default AdminSettlements;